export const view010ImageOptions = {
  angle: 'view010',
  staticOptions: {
    HullColour: 1,
    Deck: 1,
    BiminiColor: 1,
    BowOption: 1,
    UpholsteryCockpit: 1,
    AnchorStern: 1,
    AnchorBow: 1,
    Galley: 1
  },
  mattes: [
    {
      option: 'UpholsteryCockpit',
      dependency: 'TTop'
    },
    {
      option: 'AnchorStern',
      dependency: 'Engine'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/view010.js